import { c as _c } from "react/compiler-runtime";
import type { Entry } from 'contentful';
import { componentMapping } from './componentMapping';
type Props = {
  entry: Entry;
  [key: string]: unknown;
};
export function ComponentResolver(props) {
  const $ = _c(7);
  let entry;
  let otherProps;
  if ($[0] !== props) {
    ({
      entry,
      ...otherProps
    } = props);
    $[0] = props;
    $[1] = entry;
    $[2] = otherProps;
  } else {
    entry = $[1];
    otherProps = $[2];
  }
  const typeName = entry?.sys?.contentType?.sys.id as keyof typeof componentMapping;
  const Component = componentMapping[typeName];
  if (!Component) {
    return null;
  }
  const componentProps = entry.fields;
  let t0;
  if ($[3] !== Component || $[4] !== componentProps || $[5] !== otherProps) {
    t0 = <Component {...componentProps} {...otherProps} />;
    $[3] = Component;
    $[4] = componentProps;
    $[5] = otherProps;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  return t0;
}